<template>
    <div id="notifications"
        class="notifications"
    >
        <v-btn 
            v-if="is_need_render_notifications"
            class="notification-btn" 
            :color="only_information ? 'white' : 'error'" 
            fab
            x-small
            @click="control_notification_dialog(true)"
        >
            <v-icon :color="only_information ? 'error' : 'white'">
                icon-notifications
            </v-icon>
            <span class="notification-btn__text">
                {{ $t('__notification.notification_btn_tooltip_text') }}
            </span>
        </v-btn>
            
        <v-dialog
            v-if="is_need_render_notifications"
            content-class="notifications-dialog"
            v-model="notification_dialog"
            max-width="684px"
            min-height="328px"
        >  
            <v-card
                class="notifications-card"
            >
                <v-tabs
                    v-model="tab"
                    class="notifications-tabs"
                    background-color="dark-blue"
                    color="white"
                    centered
                    dark
                >
                    <v-tabs-slider color="red" />
                    <v-tab
                        v-for="tab_option in tab_options"
                        :key="tab_option"
                    >
                        {{ tab_option }}
                    </v-tab>
                </v-tabs>
                <v-icon 
                    @click="control_notification_dialog(false)"
                    class="notifications-tabs__close-btn"
                    color="white"
                >
                    icon-close
                </v-icon>
                <div class="notifications-tabs__items">
                    <v-tabs-items v-model="tab">
                        <v-tab-item
                            v-for="tab_option in tab_options"
                            :key="tab_option"
                        >
                            <AlertMessage 
                                v-if="tab_option == $t('__notification.severe_weather_advisories')" 
                                :alert_messages="alert_messages"
                            />
                            <Information 
                                v-else
                                :props_information="information"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { get_alert_message_ajax } from "@/utils/notification/alert_message.js";
    import { get_customized_information_ajax } from "@/utils/notification/information.js";
    import { mapState } from 'vuex'

    export default {
        name: 'Notifications',

        components: {
            AlertMessage: () => import('@/components/notification/alert_message.vue'),
            Information: () => import('@/components/notification/information.vue')
        },

        props: {
            system_information: {
                type: Array,
                default: () => []
            },
        },

        data() {
            return {
                tab: null,
                notification_dialog: false,
                alert_messages: [],
                customized_information: [],
            }
        },

        computed: {
            ...mapState([
                'client_name'
            ]),

            ...mapState('emap', [
                'time_choose_parameters'
            ]),

            information() {
                return [...this.system_information ?? [], ...this.customized_information]
            },

            is_need_render_notifications() {
                return this.alert_messages.length || this.information.length;
            },

            tab_options() {
                let tab_options = []
                if (this.alert_messages.length) {
                    tab_options = [...tab_options, this.$t('__notification.severe_weather_advisories')]
                }
                
                if (this.information.length) {
                    tab_options = [...tab_options, this.$t('__notification.announcements')]
                }
                return tab_options
            },

            only_information() {
                return !this.alert_messages.length;
            },
        },

        watch: {
            time_choose_parameters: {
                async handler() {
                    const { status, start_time_epoch, end_time_epoch } = this.time_choose_parameters

                    const is_newest_time = status === 'newest'
                    if (is_newest_time) {
                        return this.customized_information = await get_customized_information_ajax(this.client_name)
                    }

                    const is_past_time_valid = status === 'history' && start_time_epoch && end_time_epoch
                    if (is_past_time_valid) {
                        const transform_local_timestamp_to_utc_iso = (timestamp) => new Date(timestamp).toISOString().slice(0, 16)
                        const utc_start_time =transform_local_timestamp_to_utc_iso(start_time_epoch)
                        const utc_end_time = transform_local_timestamp_to_utc_iso(end_time_epoch)
                        const parameters = `start_time=${utc_start_time}&end_time=${utc_end_time}`
                        return this.customized_information = await get_customized_information_ajax(this.client_name, parameters)
                    }

                    // 個案
                    
                }
            }
        },

        async created () {
            const alert_message = await get_alert_message_ajax()
            this.alert_messages = alert_message.filter(({ panel_title }) => panel_title !== '天氣概況' )
            // 天氣概況每天都有，所以依照舊版邏輯，由前端篩掉
            this.customized_information = await get_customized_information_ajax(this.client_name)
            if (this.system_information.length) this.show_dialog()
        },
        
        methods: {
            show_dialog() {
                this.notification_dialog = true
                this.tab = this.tab_options.length === 2 ? 1 : 0
            },

            control_notification_dialog(boolean) {
                this.notification_dialog = boolean;
            },
        },
    }
</script>

<style lang="scss" >
    @import '../../../css/mixin';

    .notification-btn {
        position: absolute;
        top: .75rem;
        right: .8rem;
        margin: 0 .4rem;
        z-index: 2;

        @include laptop {
            position: fixed;
            top: 8px;
            right: 56px;
            left: unset;
            transform: translate(0, 0);
            z-index: 1;
        }

        @include device-hoverable {
            &:hover {
                .notification-btn {
                    &__text {
                        display: block;
                        text-transform: initial;
                    }
                }
            }
        }

        &__text {
            position: absolute;
            right: 2rem;
            display: none;
            padding: .4em .8em;
            font-size: .8rem;
        }
    }

    // 增加權重
    .notifications-dialog.notifications-dialog {
        overflow: hidden;
        min-height: 50vh;
        box-shadow: none;
    }

    .notifications-card {
        background-color: var(--white-border) !important;
        border-radius: 1rem 1rem 0 0 !important;

        .notifications-tabs {
            background-color: var(--base-dark-blue) !important;

            &__items {
                height: auto;
            }

            .dark-blue {
                background-color: var(--base-dark-blue) !important;
            }

            .v-tab {
                margin: 0 1rem;
                font-size: 1.25em;
                text-transform: capitalize;
            }

            &__close-btn {
                position: absolute;
                top: 0;
                right: 0;
                padding: .75rem;
            }
        }
    }
</style>